import './index.scss';

const selectors = {
  noJavascript: '#FurryMigration-No-Javascript',
  init: '#FurryMigration-Donation-init',
  processing: '#FurryMigration-Donation-Processing',
  payment: '#FurryMigration-Donation-Stripe',
  form: '#FurryMigration-Donations',
  amountSelect: '#FurryMigration-Donations-Select',
  otherWrap: '#FurryMigration-Donation-Other-Div',
  otherAmount: '#FurryMigration-Donation-Other',
};

const show = (element) => {
  if (element) {
    element.style.display = 'block';
  }
};

const hide = (element) => {
  if (element) {
    element.style.display = 'none';
  }
};

const setHtml = (element, html) => {
  if (element) {
    element.innerHTML = html;
  }
};

const getConfig = () => window.FurryMigrationDonationsConfig || {};

const parseDonationAmount = (amountSelect, otherAmount) => {
  let money = amountSelect.value || '';

  if (money.toLowerCase() === 'other') {
    money = otherAmount.value || '';
  }

  money = money.replace('$', '');

  return Number(money);
};

const postDonation = (token, amount, elements) => {
  const config = getConfig();
  const data = new URLSearchParams({
    stripeToken: token.id,
    stripeEmail: token.email,
    stripeAmount: amount,
    action: config.action || 'FurryMigration_Donation',
  });

  show(elements.processing);
  hide(elements.payment);

  return fetch(config.ajaxUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: data.toString(),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Donation request failed with status ${response.status}`);
      }

      return response.text();
    })
    .then((html) => {
      setHtml(elements.processing, html);
    })
    .catch((error) => {
      // Keep the failure visible to developers without exposing payment tokens.
      console.error('Donation AJAX error', error);
      setHtml(
        elements.processing,
        config.messages?.ajaxError ||
          'Sorry there was a problem processing your transaction.  Please try again later.<br /><br />Otherwise contact Furry Migration if you continuee to have problems.',
      );
    });
};

const initDonations = () => {
  const config = getConfig();
  const elements = {
    noJavascript: document.querySelector(selectors.noJavascript),
    init: document.querySelector(selectors.init),
    processing: document.querySelector(selectors.processing),
    payment: document.querySelector(selectors.payment),
    form: document.querySelector(selectors.form),
    amountSelect: document.querySelector(selectors.amountSelect),
    otherWrap: document.querySelector(selectors.otherWrap),
    otherAmount: document.querySelector(selectors.otherAmount),
  };

  if (!elements.form || !elements.amountSelect || !elements.otherAmount) {
    return;
  }

  show(elements.init);
  hide(elements.noJavascript);

  const checkout = window.StripeCheckout?.configure({
    key: config.stripePublicKey,
    image: config.stripeImage,
    locale: 'auto',
    token: (token) => {
      postDonation(token, window.FurryMigrationDonation, elements);
    },
  });

  elements.amountSelect.addEventListener('change', () => {
    if (elements.amountSelect.value.toLowerCase() === 'other') {
      show(elements.otherWrap);
    } else {
      hide(elements.otherWrap);
    }
  });

  hide(elements.init);
  show(elements.payment);

  elements.form.addEventListener('submit', (event) => {
    event.preventDefault();

    const amount = parseDonationAmount(elements.amountSelect, elements.otherAmount);
    window.FurryMigrationDonation = amount;

    if (amount <= 0 || Number.isNaN(amount)) {
      alert(config.messages?.missingAmount || 'You must select or enter a donation value');
      return;
    }

    if (amount < 5) {
      alert(config.messages?.minimumAmount || 'Sorry we can only accept donations $5 or greater.');
      return;
    }

    if (!checkout) {
      return;
    }

    checkout.open({
      name: 'Furry Migration',
      description: 'Donation to Furry Migration',
      zipCode: true,
      amount: amount * 100,
      billingAddress: true,
    });
  });

  window.addEventListener('popstate', () => {
    checkout?.close();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDonations);
} else {
  initDonations();
}
